import { LitElement, html } from 'lit-element';
import * as watchlistApi from './watchlist-api';
import watchlistEvents from './watchlist-events';

import dispatchCustomEvent from '../../utils/dispatch-custom-event';
import translate from '../../utils/webcomponents/translate';

const succesTemplate = () => {
	const labelProductRemoved = translate('watchlist', 'productRemoved', 'Product removed from watchlist.');
	const labelClose = translate('watchlist', 'close', 'Close');

	return html`
		<x-message modifier="positive" icon="checkmark" message="${labelProductRemoved}"></x-message>

		<div class="form__footer form__footer--centered">
			<button type="button" class="button js-close">${labelClose}</button>
		</div>
	`;
};

const bodyTemplate = () => {
	const labelProductRemoveAreYouSure = translate('watchlist', 'productRemoveAreYouSure', 'Are you sure you want to remove this product from your watchlist?');
	const labeLCancel = translate('watchlist', 'cancel', 'Cancel');
	const labeLConfirm = translate('watchlist', 'confirm', 'Confirm');

	return html`
		<div class="trailer text-center">
			${labelProductRemoveAreYouSure}
		</div>

		<div class="form__footer form__footer--centered">
			<button class="button js-yes">${labeLConfirm}</button>
			<button class="button button--ghost js-close">${labeLCancel}</button>
		</div>
	`;
};

class WatchlistItemRemoveForm extends LitElement {
	static get properties() {
		return {
			isError: { type: Boolean },
			isSuccess: { type: Boolean },
			isLoading: { type: Boolean },

			options: {
				type: Object,
			},
		};
	}

	constructor() {
		super();

		this.isError = false;
		this.isSuccess = false;
		this.isLoading = false;

		this.onClick = this.onClick.bind(this);
	}

	async firstUpdated() {
		super.firstUpdated();

		this.addEventListener('click', this.onClick);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.onClick);

		super.disconnectedCallback();
	}

	updated() {
		dispatchCustomEvent(this, 'updated');
	}

	render() {
		return html`
			<x-loader .isLoading="${this.isLoading}"></x-loader>

			${this.isError ? html`<x-message modifier="error" icon="warning" message="${translate('watchlist', 'somethingWentWrong', 'Something went wrong')}"></x-message>` : ''}

			${this.isSuccess ? succesTemplate() : bodyTemplate()}
		`;
	}

	onClick(e) {
		const isConfirmButton = e.target.classList && e.target.classList.contains('js-yes');

		if (isConfirmButton) {
			this.removeItem();
		}
	}

	onSuccess() {
		this.isSuccess = true;

		// dispatch it from body, otherwise IE11 can't catch it in watchlist
		dispatchCustomEvent(document.body, watchlistEvents.ITEM_REMOVE_SUCCESS, this.options);
	}

	async removeItem() {
		const { isin } = this.options;

		this.isLoading = true;
		this.isError = false;

		try {
			await watchlistApi.remove(isin);

			this.onSuccess();
		} catch (e) {
			this.isError = true;
		} finally {
			this.isLoading = false;
		}
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-watchlist-item-remove-form', WatchlistItemRemoveForm);

export default WatchlistItemRemoveForm;
